<template>
  <div class="bac_box">
    <div class="Memor-box" v-if="infolist.inside_style">
      <img
      :src="infolist.inside_style.pc_cover != null ? $uploadUrl + infolist.inside_style.pc_cover : 'images/zhanwei.png'"
      class="Memor-bigbj">
      <div class="Memor-zhong">
        <div class="Memor-left">
          <div class="Memor-pic">
            <img class="Memor-img" :src="infolist.cover">
          </div>
          <div style="width: 264px;">
            <div class="Memor-jibai">
              <!-- <img src="../../../public/images/xl.png" alt=""> -->
              <span @click="Worship">祭拜</span>
            </div>
          </div>
        </div>
        <!-- <div class="Memor-info">
          <div class="Memor-tab">
            <span :class="isave == item.id ? 'on' : ''" v-for="(item, index) in Tab" :key="index"
              @click="tab(item.id)">{{
                item.name }}</span>
          </div>
          <div class="Memor-text" v-if="isave == 0">{{ infolist.intro }}</div>
          <div class="Memor-text" v-if="isave == 1 && infolist.life_tracks.length > 0">{{
            infolist.life_tracks[0].content
          }}
          </div>
          <div class="Memor-text" v-if="isave == 2">{{ infolist.houyi }}</div>
        </div> -->
      </div>
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      Tab: [
        {
          name: '简介',
          id: 0
        },
        {
          name: '生平',
          id: 1
        },
        {
          name: '后裔',
          id: 2
        },
      ],
      isave: 0,
      setid: '',        //传过来的id
      infolist: '',     //数据
    };
  },
  created() {
    this.setid = this.$route.query.id;
    this.getData();
  },
  mounted() {

  },
  methods: {
    //获取列表数据
    getData() {
      this.$layer.loading();
      this.$http.get('memorial/' + this.setid).then((res) => {
        if (res.data.code == 200) {
          this.$layer.closeAll('loading');
          this.infolist = res.data.data;
        } else {
          this.$layer.msg(res.data.message);
        }
      })
    },

    //祭拜
    Worship() {
      this.$http.post('worship/memorial/1').then((res) => {
        if (res.data.code == 200) {
          this.$layer.msg('祭拜成功');
        } else {
          this.$layer.msg(res.data.message);
        }
      })
    },

    //切换
    tab(id) {
      this.isave = id;
    },
  },
};
</script>
<style scoped>
img {
  /* object-fit: fill; */
}

.bac_box {
  background: url(../../../public/images/jntbj2.png) no-repeat;
  width: 100%;
}

.Memor-box {
  max-width: 1200px;
  position: relative;
  /* height: calc(100vh - 107px); */
  height: 730px;

  /* overflow: hidden; */
  margin: 0 auto;
}

.Memor-bigbj {
  width: 1200px;
  height: 730px;
  object-fit: cover;
}

.Memor-zhong {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
}

.Memor-left {
  position: absolute;
  display: flex;
  align-content: space-around;
  flex-wrap: wrap;
  flex-direction: column;
}

.Memor-pic {
  /* background: url(../../../public/images/zpk.png) no-repeat; */
  /* box-shadow: -3px 1px 12px 12px rgba(33, 33, 33, 0.5); */
  width: 199px;
  height: 351px;
  background-size: 100% 100%;
  margin-top: 112px;
  margin-left: 501px;
}

.Memor-img {
  /* width: 64%;
    height: 63%; */
  object-fit: cover;
  width: 100%;
  height: 100%;
  ;
  /* margin-top: 40px;
  margin-left: 40px; */
}

.Memor-jibai {
  height: 210px;
  text-align: center;
}

.Memor-jibai img {
  width: 150px;
  height: 150px;
  position: absolute;
  bottom: 19px;
  left: 530px;
}

.Memor-jibai span {
  position: absolute;
  bottom: -12px;
  left: 529px;
  display: block;
  background: linear-gradient(139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
  border-radius: 18px;
  font-size: 18px;
  color: #FFFFFF;
  cursor: pointer;
  width: 142px;
  text-align: center;
  line-height: 30px;
}

.Memor-info {
  /* flex: 1; */
  width: 400px;
  height: 760px;
  border-radius: 10px;
  background: #F3E3D6;
  position: absolute;
  right: 50px !important;
  top: 20px;
}

.Memor-tab {
  width: 400px;
  margin: 25px auto 0;
}

.Memor-tab span {
  display: inline-block;
  width: 96px;
  height: 36px;
  background: #FFFFFF;
  border-radius: 18px;
  font-size: 18px;
  color: #333333;
  line-height: 36px;
  text-align: center;
  margin: 0 18px;
  cursor: pointer;
}

.Memor-tab span.on {
  background: #D71E1C;
  color: #fff;
}

.Memor-text {
  height: 70%;
  overflow: auto;
  padding: 0 30px 30px;
  margin-top: 30px;
  font-size: 16px;
  color: #333333;
  line-height: 32px;
}

.Memor-text::-webkit-scrollbar {
  width: 2px;
  height: 4px;
  margin-top: 10px;
}

.Memor-text::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.Memor-text::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>